import { useState, useEffect } from 'react'

const CORRECT_PIN = '2025'
const SESSION_KEY = 'ffm_unlocked'

interface PinGateProps {
  children: React.ReactNode
}

export default function PinGate({ children }: PinGateProps) {
  const [unlocked, setUnlocked] = useState(false)
  const [pin, setPin] = useState('')
  const [error, setError] = useState(false)
  const [shake, setShake] = useState(false)

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) === 'true') {
      setUnlocked(true)
    }
  }, [])

  const handleSubmit = () => {
    if (pin === CORRECT_PIN) {
      sessionStorage.setItem(SESSION_KEY, 'true')
      setUnlocked(true)
    } else {
      setError(true)
      setShake(true)
      setPin('')
      setTimeout(() => setShake(false), 600)
      setTimeout(() => setError(false), 2000)
    }
  }

  const handleKey = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSubmit()
  }

  if (unlocked) return <>{children}</>

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: '#0f1e35',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      gap: '32px',
    }}>
      <div style={{ textAlign: 'center', color: 'white' }}>
        <div style={{ fontSize: '13px', letterSpacing: '0.15em', textTransform: 'uppercase', color: '#94a3b8', marginBottom: '8px' }}>
          Motion Accountancy
        </div>
        <div style={{ fontSize: '22px', fontWeight: '600' }}>
          Financial Freedom Model
        </div>
      </div>

      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px',
        animation: shake ? 'shake 0.5s ease' : undefined,
      }}>
        <style>{`
          @keyframes shake {
            0%, 100% { transform: translateX(0); }
            20% { transform: translateX(-8px); }
            40% { transform: translateX(8px); }
            60% { transform: translateX(-6px); }
            80% { transform: translateX(6px); }
          }
        `}</style>

        <input
          type="password"
          inputMode="numeric"
          maxLength={6}
          value={pin}
          onChange={e => setPin(e.target.value.replace(/[^0-9]/g, ''))}
          onKeyDown={handleKey}
          autoFocus
          placeholder="PIN"
          style={{
            width: '160px',
            padding: '14px',
            fontSize: '24px',
            textAlign: 'center',
            letterSpacing: '0.3em',
            background: 'rgba(255,255,255,0.08)',
            border: error ? '2px solid #ef4444' : '2px solid rgba(255,255,255,0.15)',
            borderRadius: '10px',
            color: 'white',
            outline: 'none',
            transition: 'border-color 0.2s',
          }}
        />

        {error && (
          <div style={{ color: '#ef4444', fontSize: '13px' }}>Incorrect PIN</div>
        )}

        <button
          onClick={handleSubmit}
          style={{
            padding: '12px 40px',
            background: '#1e40af',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            letterSpacing: '0.05em',
          }}
        >
          Enter
        </button>
      </div>
    </div>
  )
}
